import axios from 'axios';
import { PdfExportFilters, PdfExportListResponse } from './types';

interface FetchArgs extends PdfExportFilters {
    cursor: number | null;
    limit: number;
}

export const fetchPdfExports = async (args: FetchArgs): Promise<PdfExportListResponse> => {
    const params: Record<string, string> = {};
    if (args.statuses.length > 0) params.status = args.statuses.join(',');
    if (args.from) params.from = args.from;
    if (args.to) params.to = args.to;
    if (args.accountId) params.accountId = args.accountId;
    if (args.documentId) params.documentId = args.documentId;
    if (args.trigger) params.trigger = args.trigger;
    if (args.cursor != null) params.cursor = String(args.cursor);
    params.limit = String(args.limit);

    const response = await axios.get<PdfExportListResponse>('/api/pdf-exports', { params });
    return response.data;
};
